// extracted by mini-css-extract-plugin
export default {"search-form":"SearchForm_search-form__r9IAD","search-query-input":"SearchForm_search-query-input__IUn7k","search-btn":"SearchForm_search-btn__dMS-f"};